const firebaseConfig = {
  apiKey: "AIzaSyDfOiECUlJc7CH82bq2iOvLIAiq1l9qVH0",
  authDomain: "eleventh-one.firebaseapp.com",
  projectId: "eleventh-one",
  storageBucket: "eleventh-one.appspot.com",
  messagingSenderId: "610743571478",
  appId: "1:610743571478:web:df9a1ddf84c3f78a8b9137",
};

export default firebaseConfig;
